'use strict';

import versioner from '../versioner';
import processSewer from './processSewer';
import processWater from './processWater';
import processMeterServices from './processMeterServices';

versioner['durham_sewer'] = {process: processSewer}
versioner['durham_water'] = {process: processWater}
versioner['durham_meter_services_ah'] = {process: processMeterServices}

const MODULE_NAME = 'daupler.incidents.versions.durham';

export default MODULE_NAME;
